function transform(formData, transforms) {
    if (!formData) {
        return formData;
    }
    return transforms.reduce((currentData, transformer) => {
        return transformer(currentData);
    }, formData);
}
function transformEncryptedCardNumber(formData) {
    if (formData.creditcardNumber) {
        const { creditcardNumber, ...restData } = formData;
        return {
            ...restData,
            encCreditcardNumber: creditcardNumber,
        };
    }
    return formData;
}
function transformExpirationDate(formData) {
    if (formData.expirymmyyyy && typeof formData.expirymmyyyy === 'string') {
        const { expirymmyyyy, ...restData } = formData;
        const splitExpiration = expirymmyyyy.split(' ');
        return {
            ...restData,
            expiryMonth: splitExpiration[0],
            expiryYear: splitExpiration[1],
        };
    }
    return formData;
}
function transformEncryptedCVV(formData) {
    if (formData.cvv) {
        const { cvv, ...restData } = formData;
        return {
            ...restData,
            encCvv: cvv,
        };
    }
    return formData;
}

export { transform, transformEncryptedCVV, transformEncryptedCardNumber, transformExpirationDate };
